<template>
  <div>
    <MemberManagementList
      ref="member_management_list"
      v-show="!detailShow">
    </MemberManagementList>
  </div>
</template>

<script>
import MemberManagementList from './MemberManagementList'
export default {
  name: 'MemberManagement',
  created () {
    this.callback = () => { this.updateMemberList() }
    this.$bus.$on('updateMemberList', this.callback)
  },
  destroyed () {
    this.$bus.$off('updateMemberList', this.callback)
  },
  data () {
    return {
      detailShow: false
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.detailShow = to.path.includes('/member/member_management/add') || to.path.startsWith('/member/member_management/update')
    next()
  },
  components: {
    MemberManagementList
  },
  methods: {
    updateMemberList () {
      this.$refs.member_management_list.getTableData()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
